// Validates if a string matches the pattern of a valid onboarding key
// Example of a valid key: "abc123def456ghi789jkl012mno345" (25+ alphanumeric characters or hyphens)
export const isValidOnboardingKey = (key: string): boolean => {
  const regex = /^[a-zA-Z0-9-]{25,}$/;
  return regex.test(key);
};
